import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import character from "../../assets/img/backgrounds/step2Character.png";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import date from "../../assets/img/icons/user/card-sidebar/date.png";
import calender from "../../assets/img/icons/user/calender.png";
import moment from "moment";


const Step4 = (props) => {
    const history = useHistory();
    const [launchDate, setLaunchDate] = useState(null);
    const [closingDate, setClosingDate] = useState(null);


    useEffect(() => {
        if (props?.eventData)
            setClosingDate(props?.eventData?.closingDate)
        setLaunchDate(props?.eventData?.launchDate)
    }, [])


    const handleLaunchDateChange = (date) => {
        setLaunchDate(date);
    };

    const handleClosingDateChange = (date) => {
        setClosingDate(date);
    };

    const handleSubmit = () => {


        props.setUserData({
            ...props.userData,
            eventData: {
                ...props.userData.eventData,
                launchDate: moment(launchDate).format('YYYY-MM-DD'),
                closingDate: moment(closingDate).format('YYYY-MM-DD')
            }
        })
        history.push("/easy-flow/selectionList");
    }

    const previous = () => {
        history.goBack();
    }

    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <div className="d-none d-lg-block mb--150 ml--10">
                        <div className="d-flex">
                            <div className="max-z-index">
                                <img src={character} width={201} />
                            </div>
                            <div className="bubble">
                                <div className="bubble-text position-relative">
                                    <p className="text-break text-center">Hi, Pharetra pelle ntes que mi leo id
                                        est ornare. Libero nunc gravida at mattis. Facilisi
                                        consectetur</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<Container className="">*/}
                    <Card className="mt--75 innerCard br-60" style={{ display: 'flex', flexDirection: 'row' }}>
                        <CardHeader className="card-headers">
                            <div
                                className="d-flex flex-column justify-content-center h-100 py-3">
                                <div role="button">
                                    <div>
                                        <img src={date} alt="icon" />
                                    </div>
                                    <div>
                                        <span>Launch <br /> Date</span>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="pt-0">
                            <div className="py-lg-5 card-container">
                                <>
                                    <h2 className='met-head'>
                                        Please select launching and closing dates:
                                    </h2>
                                    <Row className='mx-auto'>
                                        <Col className='mx-auto' sm={12} lg={10} xl={6}>


                                            <div className="datepicker-container">
                                                <div>
                                                    <img className='main-icon' src={calender} />
                                                    <label className='mt-5 art-head'>Launch Date:</label>
                                                    <DatePicker
                                                        className='date-pick'
                                                        selected={launchDate}
                                                        onChange={handleLaunchDateChange}
                                                        dateFormat="yyyy-MM-dd"

                                                    />
                                                </div>
                                                <div>
                                                    <img className='main-icon' src={calender} />
                                                    <label className='mt-4 art-head'>Closing Date:</label>
                                                    <DatePicker
                                                        className='date-pick'
                                                        selected={closingDate}
                                                        onChange={handleClosingDateChange}
                                                        dateFormat="yyyy-MM-dd"

                                                    />
                                                </div>
                                            </div>


                                        </Col>
                                        <Col className='mx-auto' sm={12} lg={10} xl={6}>
                                            <p className='art-head'>
                                                Selected Slots
                                            </p>
                                            <div className="datepicker-container">
                                                <Button className='calendar-icon '>
                                                    Delete
                                                </Button>
                                                <DatePicker
                                                    className='date-pick px-3 my-2'
                                                    // selected={launchDate}

                                                    dateFormat="yyyy-MM-dd"
                                                    placeholderText="Slot 1"
                                                />

                                            </div>
                                            <div className="datepicker-container">
                                                <Row>

                                                    <Button className='calendar-icon clander-icon1 '>
                                                        Done
                                                    </Button>


                                                    <Button className='calendar-icon clander-icon2 '>
                                                        Delete
                                                    </Button>

                                                </Row>
                                                <DatePicker
                                                    className='date-pick px-3 my-2 '
                                                    // selected={launchDate}

                                                    dateFormat="yyyy-MM-dd"
                                                    placeholderText="Slot 2"
                                                />
                                            </div>
                                            <div className="datepicker-container">
                                                <Button className='calendar-icon '>
                                                    Delete
                                                </Button>

                                                <DatePicker
                                                    className='date-pick px-3 my-2 '
                                                    // selected={launchDate}

                                                    dateFormat="yyyy-MM-dd"
                                                    placeholderText="Slot 3"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            </div>
                            <Container className="mt-5">
                                <Row>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="previous-button text-white w-100" onClick={previous}
                                            color="">Previous</Button>
                                    </Col>
                                    <Col sm={12} xs={12} md={6} lg={6}></Col>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                            onClick={handleSubmit}
                                            color="">Next</Button>
                                    </Col>
                                </Row>
                            </Container>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Step4;